"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useMenuContext } from "../Menu.context.mjs";
import Menu_module_default from "../Menu.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Menu/MenuDivider/MenuDivider.tsx
const MenuDivider = factory((props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("MenuDivider", null, props);
	return /* @__PURE__ */ jsx(Box, {
		...useMenuContext().getStyles("divider", {
			className,
			style,
			styles,
			classNames
		}),
		...others
	});
});
MenuDivider.classes = Menu_module_default;
MenuDivider.displayName = "@mantine/core/MenuDivider";
//#endregion
export { MenuDivider };

//# sourceMappingURL=MenuDivider.mjs.map